import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { CustomerReferralStageList } from '@/services/pointConfiguration/pointConfiguration.types';
import React from 'react';
import useReferralStageStatus from '../hooks/useReferralStageStatus';
import { getColumns } from './Column';

export function ReferralStageTable({
  data,
  isLoading,
  pagination,
}: {
  data: CustomerReferralStageList[];
  isLoading: boolean;
  pagination: Pagination;
}) {
  const { onOpen } = useDialogFormStore();
  const { openConfirmation } = useConfirmationStore();
  const { t } = useDynamicLocale();
  const { mutateAsync: updateStatus } = useReferralStageStatus();
  const columns = React.useMemo(
    () => getColumns(t, onOpen, updateStatus, openConfirmation),
    [t, onOpen, updateStatus, openConfirmation],
  );
  const onAddnew = () => {
    onOpen({
      modalTitle: 'hi',
      title: 'hi',
      okText: 'hi',
      size: 'lg',
      cancelText: 'hi',
      component: '',
    });
  };
  const { table } = useDataTable({
    data,
    columns,
    pageCount: pagination.totalPages,
    meta: {
      title: t('pointManagement.pointsConfiguration.referralStage.title'),
      action: onAddnew,
      actionKey: 'onAddNew',
      actionDisabled: true,
      loading: isLoading,
      totalPage: pagination.totalItems,
    },
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable className="rounded-t-none" table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
